import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_3 = ["href", "target"]
const _hoisted_4 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSkeleton',
  props: {
    isLoading: { type: Boolean },
    link: {},
    target: {},
    onClick: { type: Function },
    disabledClick: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (!_ctx.link)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_a_spin, {
              key: 0,
              tip: "Loading...",
              size: "large",
              class: "animate-pulse"
            }))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.disabledClick)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.link,
          target: _ctx.target,
          onclick: "return false"
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_a_spin, {
                  key: 0,
                  tip: "Loading...",
                  size: "large",
                  class: "animate-pulse"
                }))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: _ctx.link,
          target: _ctx.target
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_a_spin, {
                  key: 0,
                  tip: "Loading...",
                  size: "large",
                  class: "animate-pulse"
                }))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_3))
}
}

})